export default {
  path: '/ticket_actions',
  name: 'ticket_actions',
  component: () => import('../components/ticketaction/Layout'),
  redirect: { name: 'TicketactionList' },
  meta: {
    breadcrumb: 'ticket.ticketactions',
  },
  children: [
    {
      name: 'TicketactionList',
      path: '',
      component: () => import('../views/ticketaction/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    /*
    {
      name: 'TicketactionCreate',
      path: 'new',
      component: () => import('../views/ticketaction/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },

    {
      name: 'TicketactionUpdate',
      path: ':id/edit',
      component: () => import('../views/ticketaction/Update'),
      meta: {
        breadcrumb: 'ticket.ticketaction',
      },
    },
    {
      name: 'TicketactionShow',
      path: ':id',
      component: () => import('../views/ticketaction/Show'),
      meta: {
        breadcrumb: 'ticket.ticketaction',
      },
    }
    */
  ]
};
